import { computed, reactive, ref } from 'vue';
import moment from 'moment';

export default {
  name: 'EventCardComponent',
  props: {
    event: {
      type: Object,
      required: true,
    },
    userEvents: {
      type: Array,
      required: false,
      default: [],
    },
    user: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {

    const state = reactive({

      event: ref(props.event),
      eventForSale: ref(props.event.replay.sellable),
      onSale: computed(() => {
        if (Boolean(props.event.sale.price)) {
          if (props.event.sale.dates.ends_at && inThePast(props.event.sale.dates.ends_at)) {
            return false;
          }
          return true;
        }
        return false;
      }),
      salePrice: ref(props.event.sale.price),
      detailsUrl: computed(() => {
        if (props.event.in_person_product_handle) {
          if (props.event.in_person_details_url && !inThePast(props.event.ends_at)) {
            return props.event.in_person_details_url;
          }
        }
        return false;
      }),
      ribbonText: (userEvents) => {

        if (userHasEvent(userEvents)) {
          if (inThePast(state.event.starts_at)) {
            if (userEventIsExpired(userEvents)) {
              return 'expired';
            } else {
              // user event is not expired
              return 'active';
            }
          } else {
            // event is not in the past
            return 'purchased';
          }
        } else {
          // user does not have event
          if (state.onSale) {
            return 'sale';
          }
        }

        return '';
      },
      ribbonBarColorClass: (userEvents) => {

        if (userHasEvent(userEvents)) {
          if (inThePast(state.event.starts_at)) {
            if (userEventIsExpired(userEvents)) {
              return 'koc-event-expired';
            } else {
              // user event is not expired
              return 'koc-event-active';
            }
          } else {
            // event is not in the past
            return 'koc-event-active';
          }
        } else {
          // user does not have event
          if (state.onSale) {
            return 'koc-event-sale';
          }
        }

        return '';
      },
      showRibbonBar: (userEvents) => {

        if (userHasEvent(userEvents)) {
          if (inThePast(state.event.starts_at)) {
            if (userEventIsExpired(userEvents)) {
              return true;
            } else {
              // user event is not expired
              return true;
            }
          } else {
            // event is not in the past
            return true;
          }
        } else {
          // user does not have event
          if (state.onSale) {
            return true;
          }
        }

        return false;
      },
      showLoginLink: (userEvents, user) => {

        if (!userHasEvent(userEvents)) {
          if (!user) {
            return true;
          }
        }

        return false;
      },
      showLearnMore: (userEvents) => {

        if (!userHasEvent(userEvents)) {
          if (!inThePast(state.event.starts_at)) {
            return true;
          }
          if (eventIsLive(state.event.starts_at, state.event.ends_at)) {
            return true;
          }
        }

        return false;
      },
      showPrice: (userEvents) => {

        if (userHasEvent(userEvents)) {
          if (!userEventIsExpired(userEvents)) {
            return false;
          }
        }
        if (eventIsLive(state.event.starts_at, state.event.ends_at)) {
          return true;
        }
        if (!state.eventForSale) {
          if (inThePast(state.event.starts_at)) {
            return false;
          }
        }

        return true;
      },
      actionUrl: (userEvents) => {

        if (userHasEvent(userEvents)) {
          if (inThePast(state.event.ends_at)) {
            if (!userEventIsExpired(userEvents)) {
              if (state.event.replay.url) {
                return state.event.replay.url;
              }
            } else {
              // user event is expired
              return state.event.checkout_url;
            }
          } else {
            // event is not in the past
            if (eventIsLive(state.event.starts_at, state.event.ends_at)) {
              if (state.event.live_event_url) {
                return state.event.live_event_url;
              }
            }
            if (state.event.live_event_url) {
              return state.event.live_event_url;
            }
          }
        } else {
          // user does not have event
          if (inThePast(state.event.starts_at)) {
            if (eventIsLive(state.event.starts_at, state.event.ends_at)) {
              return state.event.checkout_url;
            }
            if (state.eventForSale) {
              return state.event.checkout_url;
            }
          } else {
            // event is not in the past
            return state.event.checkout_url;
          }
        }

        return null;
      },
      showActionDateText: (userEvents) => {

        if (userHasEvent(userEvents)) {
          if (inThePast(state.event.starts_at)) {
            if (!userEventIsExpired(userEvents)) {
              return true;
            }
          }
        }

        return false;
      },
      showPipe: (userEvents) => {

        if (eventIsLive(state.event.starts_at, state.event.ends_at)) {
          return false;
        }

        if (userHasEvent(userEvents)) {
          if (inThePast(state.event.starts_at)) {
            if (!userEventIsExpired(userEvents)) {
              return true;
            }
          }
        } else {
          // user does not have event
          if (inThePast(state.event.starts_at)) {
            if (state.eventForSale) {
              return true;
            }
          } else {
            // event is not in the past
            return true;
          }
        }

        return false;
      },
      actionText: (userEvents) => {

        if (userHasEvent(userEvents)) {
          if (inThePast(state.event.ends_at)) {
            if (userEventIsExpired(userEvents)) {
              if (state.eventForSale) {
                return 'buy again';
              } else {
                // event is not for sale
                return 'replay not for sale at this time';
              }
            } else {
              // user event is not expired
              if (!state.event.replay.url) {
                return 'replay coming soon';
              }
              return 'watch now';
            }
          } else {
            // event is not in the past
            if (eventIsLive(state.event.starts_at, state.event.ends_at)) {
              if (state.event.live_event_url) {
                return 'watch now';
              }
            }

            if (state.event.live_event_url) {
              return 'starting soon';
            }

            return 'live link coming soon';

          }
        } else {
          // user does not have event
          if (eventIsLive(state.event.starts_at, state.event.ends_at)) {
            return 'register now';
          }
          if (inThePast(state.event.starts_at)) {
            if (state.eventForSale) {
              return 'buy replay';
            } else {
              // event not for sale
              return 'replay is not for sale at this time';
            }
          } else {
            // event is not in the past
            return 'register now';
          }
        }

        return '';
      },
      actionDateText: (userEvents) => {

        if (userHasEvent(userEvents)) {
          if (inThePast(state.event.starts_at)) {
            if (!userEventIsExpired(userEvents)) {
              if (!eventIsLive(state.event.starts_at, state.event.ends_at)) {
                return getExpiresText(userEvents);
              }
            }
          }
        }

        return '';
      },
      actionClass: (userEvents) => {

        if (userHasEvent(userEvents)) {
          if (inThePast(state.event.starts_at)) {
            if (userEventIsExpired(userEvents)) {
              if (state.eventForSale) {
                return 'koc-link';
              } else {
                // event is not for sale
                return 'koc-fade';
              }
            } else {
              // user event is not expired
              if (!state.event.replay.url) {
                return 'koc-fade';
              }
              return 'koc-link';
            }
          } else {
            // event is not in the past
            if (eventIsLive(state.event.starts_at, state.event.ends_at)) {
              if (state.event.live_event_url) {
                return 'koc-link';
              }
            }

            if (state.event.live_event_url) {
              return 'koc-link';
            }

            return 'koc-fade';

          }
        } else {
          // user does not have event
          if (eventIsLive(state.event.starts_at, state.event.ends_at)) {
            return 'koc-link';
          }
          if (inThePast(state.event.starts_at)) {
            if (state.eventForSale) {
              return 'koc-link';
            } else {
              // event not for sale
              return 'koc-fade';
            }
          } else {
            // event is not in the past
            return 'koc-link';
          }
        }

        return '';
      },
      headerDateText: (userEvents) => {

        if (eventIsLive(state.event.starts_at, state.event.ends_at)) {
          return 'Live Now';
        }
        if (userHasEvent(userEvents)) {
          if (inThePast(state.event.starts_at)) {
            return `Aired ${formatDate(state.event.starts_at)}`;
          } else {
            // event is not in the past
            return `Event Starts in ${getTimeUntil()} | ${formatDate(state.event.starts_at)}`;
          }
        } else {
          // user does not have event
          if (inThePast(state.event.starts_at)) {
            return `Aired ${formatDate(state.event.starts_at)}`;
          } else {
            // event is not in the past
            return formatDate(props.event.starts_at);
          }
        }

        return '';
      },
    });

    const formatPrice = (price) => {
      return `$${price}`;
    };

    const getTimeUntil = () => {
      let dateString = '';
      let startDate = new Date(state.event.starts_at);
      let now = new Date();
      let diffInSeconds = Math.abs(startDate - now) / 1000;
      let days = Math.floor(diffInSeconds / 60 / 60 / 24);
      let hours = Math.floor(diffInSeconds / 60 / 60 % 24);
      if (days > 1) {
        dateString = days + ' Days ';
      } else {
        let hoursCalc = days * 24 + hours;
        if (hoursCalc > 1) {
          dateString = hoursCalc + ' Hours ';
        } else {
          let minutes = Math.floor(diffInSeconds / 60);
          dateString = minutes + ' Minutes ';
        }
      }
      return dateString;
    };

    const getExpiresText = (userEvents) => {
      let userEvent = userEvents.find(events => events.event.id === state.event.id);
      if (userEvent) {
        return 'Expires ' + formatDate(userEvent.access.event.expires_at);
      }

      return 'Expires ' + formatDate(state.event.replay.dates.expires);
    };

    const userHasEvent = (userEvents) => {
      if (userEvents.length) {
        return userEvents.some(events => events.event.id === state.event.id);
      }
      return false;
    };

    const getUserEvent = (userEvents) => {
      if (userHasEvent(userEvents)) {
        return userEvents.find(events => events.event.id === state.event.id);
      }
      return null;
    };

    const getUserEventExpiration = (userEvents) => {
      if (userHasEvent(userEvents)) {
        let userEvent = userEvents.find(events => events.event.id === state.event.id);
        return userEvent.access.event.expires_at;
      }
      return null;
    };

    const userEventIsExpired = (userEvents) => {
      let expires = getUserEventExpiration(userEvents);
      return expires ? inThePast(expires) : false;

    };

    const inThePast = (datetime) => {
      let date = new Date(datetime);
      let now = new Date();

      return (now > date);
    };

    const eventIsLive = (start, end) => {
      let startDate = new Date(start);
      let endDate = new Date(end);
      let now = new Date();

      return (now >= startDate && now <= endDate);
    };

    const formatDate = (date) => moment(String(date)).format('MMMM D, YYYY');

    return {
      state,
      formatPrice,
      getTimeUntil,
      inThePast,
      getExpiresText,
      userHasEvent,
      getUserEvent,
      getUserEventExpiration,
      userEventIsExpired,
      eventIsLive
    };
  },
  methods: {
    login: async function() {
      this.$emit('show-login');
    },
  },
};
